<template>
  <div class="need-help-section" id="ajuda" v-if="!loadingFaqs">
    <TheSecondHead
      chipText="Saiba mais"
      titleText="Precisa de ajuda?"
      subtitleText="Confira as perguntas mais frequentes sobre nosso serviço e tire suas dúvidas!"
    />
    <TheFaqList :faqs="faqs" />
    <v-btn
      class="default-button talk-button"
      type="button"
      @click="buttonClicked()"
    >
      Vamos conversar
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from "@/stores/global";
const store = useGlobalStore();
const { faqs, loadingFaqs } = storeToRefs(store);

const props = defineProps<{
  creditor: CreditorProfile;
}>();

onMounted(async () => {
  await store.getFaqs(props.creditor.chave);
});

const router = useRouter();
const buttonClicked = () => router.push("/contato#contact-form");
</script>

<style lang="scss"></style>
